<template lang="pug">
.card-area
  .title
    span {{title}}
  .content
    span.text {{this.area}} {{ isHa ? 'ha' : ''}}
</template>
<script>
import Utils from '@/utils/utils'

export default {
  props: {
    title: String,
    value: Number,
    isHa: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      cardType: '',
      icon: ''
    }
  },
  computed: {
    area () {
      if (this.isHa) {
        return this.format(this.value, { prefix: '', suffix: '', thousands: '.', decimal: ', ', precision: 4 })
      } else {
        return `R$ ${this.value}`
      }
    }
  },
  methods: {
    format: Utils.format
  }
}
</script>

<style lang="scss" scoped>
.card-area {
  display: flex;
  justify-content: space-between;
  border: 2px solid;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0px 3px 6px #00000029;
  margin-bottom:20px;
  flex-wrap: wrap;
  flex-basis: 100%;
  height: 85px;
  background-color: #3d9c67;
  color: #3d9c67;
}

.title {
  font-size: 16px;
  color: white;
  padding-bottom: 5px;
}

.text {
  font-size: 14px;
  font-weight: bold;
  color:white;
}

.content {
  display: flex;
  justify-content: space-between;
  width:100%;
  align-items: flex-end;
}

i {
  font-size:40px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/relatorios/components/CardArea.vue